import { Component, EventEmitter, Input, Output } from "@angular/core";
import { HelpTarget } from "src/app/interfaces/helpTarget";

@Component({
    selector: "circ-filter-group",
    templateUrl: "./filter-group.component.html",
    styleUrls: ["./filter-group.component.scss"],
    standalone: false
})
export class FilterGroupComponent {
  @Input() title: string;
  @Input() actions: FilterActions[];
  @Input() isLoading: boolean;
  @Input() selectedFilterId: string;

  @Output() filterClick = new EventEmitter<string>();

  public readonly helpTarget = HelpTarget.Circulation;

  public onFilterClick(id: string): void {
    this.filterClick.emit(id);
    //Dirty state
    this.selectedFilterId = id;
  }
}

class FilterActions {
  id: string;
  displayName: string;
}
